import React from 'react'
import PandaDocLogo from '../../images/pandadoc.png'
import { Tooltip } from '@mui/material'
import { PandaDocument } from 'types'

const PandaDocLinkIcon = ({ size, document }: { size: number; document?: PandaDocument }) => {
  return (
    <>
      <Tooltip title="Open Contract">
        {size ? (
          <img style={{ width: size, borderRadius: 25 }} src={PandaDocLogo} />
        ) : (
          <img style={{ width: 40, borderRadius: 25 }} src={PandaDocLogo} />
        )}
      </Tooltip>
    </>
  )
}

export default PandaDocLinkIcon
